import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    ActionRequiredCount,
    getNotificationDetailRequest,
    getNotificationsRequest,
    IRejectWithValue,
    MobileNotification,
    MobileNotificationDetail,
    NotificationCategory,
    PhpClientPaginatedResponse,
    PhpResponse,
} from "../../../types";
import { phpClient } from "../../../network";

const EMPTY_ACTION_REQUIRED_COUNT: ActionRequiredCount = {
    total: 0,
    by_category: {},
};

export const getActionRequiredCount = createAsyncThunk<
    ActionRequiredCount,
    { forceRefresh?: boolean } | void,
    IRejectWithValue
>("mobile/getActionRequiredCount", async (_data, { rejectWithValue }) => {
    try {
        const response = await phpClient.post<PhpResponse<ActionRequiredCount>>({
            url: "/notification/action_required_count",
            data: {},
        });

        return response.data || EMPTY_ACTION_REQUIRED_COUNT;
    } catch (error: any) {
        return rejectWithValue(error.message || "An error occurred");
    }
});

export const getNotifications = createAsyncThunk<
    PhpClientPaginatedResponse<MobileNotification>,
    getNotificationsRequest,
    IRejectWithValue
>("mobile/getNotifications", async (data, { rejectWithValue }) => {
    try {
        const response = await phpClient.post<PhpClientPaginatedResponse<MobileNotification>>({
            url: "/notification",
            data,
        });

        return response;
    } catch (error: any) {
        return rejectWithValue(error.message || "An error occurred");
    }
});

export const getNotificationDetail = createAsyncThunk<
    MobileNotificationDetail | undefined,
    getNotificationDetailRequest,
    IRejectWithValue
>("mobile/getNotificationDetails", async (data, { rejectWithValue }) => {
    const { notificationId } = data;
    try {
        const response = await phpClient.post<PhpResponse<MobileNotificationDetail>>({
            url: `/notification/details/${notificationId}`,
            data: {
                notification_id: notificationId,
                read_status: 1,
            },
        });

        return response.data;
    } catch (error: any) {
        return rejectWithValue(error.message || "An error occurred");
    }
});

export const getNotificationCategories = createAsyncThunk<
    NotificationCategory[],
    void,
    IRejectWithValue
>("mobile/getNotificationCategories", async (_, { rejectWithValue }) => {
    try {
        const response = await phpClient.get<PhpResponse<NotificationCategory[]>>({
            url: "/notification/notification_category",
            data: {},
        });

        return response.data || [];
    } catch (error: any) {
        return rejectWithValue(error.message || "An error occurred");
    }
});
